<template>
  <div class="reseller-modal-layer">
    <div class="reseller-modal-wrap">
      <div class="reseller-modal">
        <div class="reseller-modal-header">
          <h1>상세 검색</h1>
        </div>
        <div class="reseller-modal-contents">
          <fieldset class="modal">
            <div class="lookup-wrap">
              <dl>
                <dt>기간</dt>
                <dd>
                  <vue-monthly-picker
                    v-model="selectedStartMonth"
                    dateFormat="YYYY.MM"
                    alignment="left"
                    :clearOption="false"
                    selectedBackgroundColor="#5393e2"
                    :monthLabels="locale"
                  />
                  <i class="fal fa-calendar-check"></i>
                </dd>
                <dd>
                  <span class="dash">-</span>
                </dd>
                <dd>
                  <vue-monthly-picker
                    v-model="selectedEndMonth"
                    dateFormat="YYYY.MM"
                    alignment="left"
                    :clearOption="false"
                    selectedBackgroundColor="#5393e2"
                    :monthLabels="locale"
                  />
                  <i class="fal fa-calendar-check"></i>
                </dd>
              </dl>
              <dl>
                <dt>정렬</dt>
                <dd>
                  <reseller-radio
                    name="orderby"
                    label="desc"
                    value="desc"
                    v-model="orderby"
                  >
                    최신순
                  </reseller-radio>
                  <reseller-radio
                    name="orderby"
                    label="asc"
                    value="asc"
                    v-model="orderby"
                  >
                    과거순
                  </reseller-radio>
                </dd>
              </dl>
            </div>
          </fieldset>
        </div>
        <div class="reseller-modal-footer">
          <div class="button-area">
            <reseller-button type="primary" @click="searchCalculate">
              검색
            </reseller-button>
            <reseller-button @click="closeSearchModal">취소</reseller-button>
          </div>
        </div>
        <div class="reseller-modal-close" @click="closeSearchModal">
          <i class="fal fa-times"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import ResellerRadio from '@/components/RadioButton.vue';

export default {
  components: {
    ResellerRadio
  },
  props: {},

  data() {
    return {
      selectedStartMonth: moment().subtract(1, 'years'),
      selectedEndMonth: moment(),
      startDate: '',
      endDate: '',
      status: '0',
      orderby: 'desc',
      locale: [
        '1월',
        '2월',
        '3월',
        '4월',
        '5월',
        '6월',
        '7월',
        '8월',
        '9월',
        '10월',
        '11월',
        '12월'
      ]

      //
    };
  },

  watch: {
    selectedStartMonth(date) {
      if (this.selectedStartMonth > this.selectedEndMonth) {
        alert('기간을 확인해 주세요.');
        this.selectedStartMonth = moment().subtract(1, 'years');
      } else {
        this.$_getStartDate();
      }
    },

    selectedEndMonth(date) {
      if (this.selectedEndMonth < this.selectedStartMonth) {
        alert('기간을 확인해 주세요.');
        this.selectedEndMonth = moment();
      } else {
        this.$_getEndDate();
      }
    }
  },

  computed: {},

  mounted() {
    this.$_getStartDate();
    this.$_getEndDate();
  },

  methods: {
    $_getStartDate() {
      this.startDate = this.selectedStartMonth.format('YYYY-MM') + '-01';
    },

    $_getEndDate() {
      let temp = new Date(this.selectedEndMonth);
      let searchEndDate = new Date(temp.getFullYear(), temp.getMonth() + 1, 0);
      let endMonth =
        searchEndDate.getMonth() + 1 > 9
          ? searchEndDate.getMonth() + 1
          : '0' + (searchEndDate.getMonth() + 1);

      this.endDate =
        searchEndDate.getFullYear() +
        '-' +
        endMonth +
        '-' +
        searchEndDate.getDate();
    },
    searchCalculate() {
      let start_date = new Date(this.startDate);
      let end_date = new Date(this.endDate);
      if (start_date.getTime() > end_date.getTime()) {
        alert('검색 날짜를 다시 확인 후 검색해주세요.');
        return;
      }
      let params = {
        start_date: this.startDate,
        end_date: this.endDate,
        orderby: this.orderby
      };

      this.$emit('searchCalculate', params);
    },
    closeSearchModal() {
      this.$emit('closeSearchModal');
    }
  }
};
</script>

<style></style>
